import { z } from "zod"

export const CompanyLegalInfoSchema = z.object({
  legalName: z.string().min(1).max(30),
  legalLocation: z.string().min(1, "Field is required"),
})

export type CompanyLegalInfoFormValues = z.infer<typeof CompanyLegalInfoSchema>
